<template>
  <v-dialog v-model="dialog" max-width="1100" persistent>
    <v-card>
      <v-card-title class="text-h6 font-weight-bold d-flex align-center">
        <v-icon left color="primary" class="mr-2">mdi-account-details</v-icon>
        Danh sách công việc của: {{ receiverName }}
        <v-spacer />
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="tasks"
          :loading="isLoading"
          loading-text="Đang tải dữ liệu..."
          item-key="_id"
        >
          <template v-slot:item.creatorData="{ item }">
            <span class="font-weight-medium text--primary">
              {{ item.creatorData.name || '---' }}
            </span>
          </template>

          <template v-slot:item.title="{ item }">
            <span>{{ item.title }}</span>
          </template>

          <template v-slot:item.status="{ item }">
            <v-chip small :color="statusColor(item.status)" dark label>
              {{ statusText(item.status) }}
            </v-chip>
          </template>

          <template v-slot:item.due_date="{ item }">
            <span>{{ $options.filters.ddmmyyyy(item.due_date) }}</span>
          </template>

          <template v-slot:item.updatedAt="{ item }">
            <span>{{ new Date(item.updatedAt).toLocaleString('vi-VN') }}</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TaskReportDetail',
  props: {
    state: Boolean,
    receiverId: String,
    receiverName: String,
  },
  data() {
    return {
      dialog: this.state,
      tasks: [],
      isLoading: false,
      headers: [
        { text: 'Người giao việc', value: 'creatorData' },
        { text: 'Tiêu đề', value: 'title' },
        { text: 'Trạng thái', value: 'status' },
        { text: 'Hạn hoàn thành', value: 'due_date' },
        { text: 'Cập nhật gần nhất', value: 'updatedAt' },
      ],
    }
  },
  watch: {
    state(val) {
      this.dialog = val
      if (val) {
        this.fetchTasks()
      }
    },
    dialog(val) {
      if (!val) this.$emit('close')
    },
  },
  methods: {
    async fetchTasks() {
      this.isLoading = true
      try {
        const res = await this.$store.dispatch('tasknew/findTaskByReceiver', {
          receiverId: this.receiverId,
          title: '',
          status: '',
          page: 1,
          limit: 100,
        })
        this.tasks = res.data || []
      } catch (err) {
        this.$alert.error('Không thể tải danh sách công việc')
      } finally {
        this.isLoading = false
      }
    },
    statusText(status) {
      const map = {
        not_started: 'Chưa bắt đầu',
        in_progress: 'Đang thực hiện',
        completed: 'Hoàn thành',
        waiting: 'Chờ đánh giá',
      }
      return map[status] || status
    },
    statusColor(status) {
      const map = {
        not_started: 'grey',
        in_progress: 'orange',
        completed: 'green',
        waiting: 'red',
      }
      return map[status] || 'grey'
    },
  },
}
</script>

<style scoped></style>
